// extracted by mini-css-extract-plugin
export var pressReleaseCard = "internalPageReleaseList-module--pressReleaseCard--ZYydb";